import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import * as p from 'app-constants/policies'
// import * as pc from 'app-constants/products'
// import { Tag } from 'antd'

class Travel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      policy: this.props.policy,
      processed: this.props.policy.isProcessed,
      scheduleDocument: null,
      countries: ''
    }
  }

  render() {
    let { policy } = this.props

    return (
      <div>
        <form>
          <div className="text-center mb-2">
            <div className="alert alert-dark">
              <span>PAYMENT STATUS: </span>{' '}
              <span
                className={`badge badge-${
                  policy.paymentColor === 'green' ? 'success' : 'danger'
                }`}
              >
                {policy.payment}
              </span>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-6 mb-4">
              <label className="mb-1">First Name</label>
              <input
                type="text"
                disabled
                value={policy.user.firstName ? policy.user.firstName : ''}
                className="form-control"
                aria-describedby="basic-addon1"
              />
            </div>
            <div className="col-md-6 mb-4">
              <label className="mb-1">Last Name</label>
              <input
                type="text"
                disabled
                value={policy.user.lastName ? policy.user.lastName : ''}
                className="form-control"
                aria-describedby="basic-addon1"
              />
            </div>

            <div className="col-md-6 mb-4">
              <label className="mb-1">Email Address</label>
              <input
                type="text"
                disabled
                value={policy.user.email}
                className="form-control"
                aria-describedby="basic-addon1"
              />
            </div>

            <div className="col-md-6 mb-4">
              <label className="mb-1">Policy</label>
              <input
                type="text"
                disabled
                value={policy.product}
                className="form-control"
                aria-describedby="basic-addon1"
              />
            </div>

            <div className="col-md-6 mb-4">
              <label className="mb-1">Company</label>
              <input
                type="text"
                disabled
                value={policy.company}
                className="form-control"
                aria-describedby="basic-addon1"
              />
            </div>
            <div className="col-md-6 mb-4">
              <label className="mb-1">Value</label>
              <input
                type="text"
                disabled
                value={policy.premiumAmount}
                className="form-control"
                aria-describedby="basic-addon1"
              />
            </div>

            <div className="col-md-6 mb-4">
              <label className="mb-1">Duration</label>
              <input
                type="text"
                disabled
                value={policy.duration}
                className="form-control"
                aria-describedby="basic-addon1"
              />
            </div>

            <div className="col-md-6 mb-4">
              <label className="mb-1">Countries</label>
              <input
                type="text"
                disabled
                value={policy.countries}
                className="form-control"
                aria-describedby="basic-addon1"
              />
            </div>

            <div className="col-md-12 mt-4">
              <div className="row">
                <div
                  className="col"
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  {/* <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={this.props.handleCancel}
                  >
                    Close
                  </button> */}
                  {[p.PAID, p.ACTIVE].includes(policy.status) ? (
                    <Link
                      to={{
                        pathname: `/claims/travel/new/${policy.policyId}`
                      }}
                      className="navbar__link"
                    >
                      <button className="btn btn--width-lng btn--gradient-primary">
                        Make Claim
                      </button>
                    </Link>
                  ) : (
                    <Link
                      to={`/buy-travel-insurance/${policy.productId}/buy`}
                      className="navbar__link"
                    >
                      <button className="btn btn--width-lng btn--gradient-primary">
                        Make Payment
                      </button>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

export default Travel
